import { IRootState } from "@iloq/shared/IRootState";
import { IUser } from "@iloq/shared/IUser";
import React from "react";
// import VueI18n from "vue-i18n";
// import VueRouter, { RouteRecord } from "vue-router";

// Let's avoid vue dependencies in shared code
type RouteRecord = {
  meta: {
    rootRoute: string;
  };
  [key: string]: any;
};
type VueRouter = {
  push: (to: string) => void;
  /** Is this actually react-router instead of vue-router, since ProfileMenu.tsx is using $router.history.push? */
  history?: {
    push: (to: string) => void;
  };
  [key: string]: any;
};
// type VueI18n = any;

// TODO: We should define the store state types in a shared location
export type VueContextType = {
  $route: RouteRecord;
  $router: VueRouter;
  $store: {
    state: IRootState;
    // state: {
    //   user: IUser;
    //   // Partner info module
    //   partnerInfo: {
    //     partnerInfo: IPartnerInfo & Record<string, any>;
    //     [key: string]: any;
    //   };
    //   productSearch: {
    //     searchResult: IPartnerProductSearchResult;
    //     [key: string]: any;
    //   };
    //   [key: string]: any;
    // };
    commit: (mutation: string, payload: any) => void;
    [key: string]: any;
  };
  $t: (key: string, values?: any) => string;
  // $t: (key: VueI18n.Path, values?: VueI18n.Values) => VueI18n.TranslateResult;
  messages: Record<string, Record<string, string>>;
  locale: string;
  user: IUser;
  clientVersion: string;
  partnerProgramKnowledgeBaseURL: string;
  partnerProgramBrandStoreURL: string;
  partnerProgramDashboardCTAURL: string;
  partnerProgramNPSReportsCTAURL: string;
  partnerProgramPartnerPointsCTAURL: string;
  mapboxAccessToken: string;
};

const VueContext = React.createContext({} as VueContextType);

export default VueContext;
